import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import DynamicTableComponent from './DynamicTableComponent';
import { v4 as uuid } from 'uuid';
import { useEffect } from 'react';

const ItAssetListForCRM = () => {
  const { CRMStore, dashboardStore, userStore:{ user } } = useStore();
  const { itAssetTableDetails, handleInventorySearch, handleIntentorySort } =
    CRMStore;
  useEffect(() => {
    handleInventorySearch(1, '');
    dashboardStore.updateCountOrderMenu(user?.id || '')
    // eslint-disable-next-line
  }, []);
  const searchFunction = (column: any, order: any) => {
    console.log(order, column);
  };
  const paginateFunction = (e: number) => {
    if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      handleIntentorySort(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        e,
      );
    } else {
      const searchData =
        Object.keys(dashboardStore.dashboard.searchfilterparams).length === 0
          ? ''
          : JSON.stringify(dashboardStore.dashboard.searchfilterparams);
      handleInventorySearch(e, searchData);
    }
    dashboardStore.setTagPageNumFunc(e);
    itAssetTableDetails.pageNumber = e;
  };
  return (
    <div style={{ margin: '0% 0.5%' }}>
      <h2 style={{ marginLeft: '20px' }}>IT Asset List</h2>
      <DynamicTableComponent
        key={uuid()}
        data={itAssetTableDetails.tableData}
        name={'IT Asset List'}
        actiontype={''}
        pageFunc={paginateFunction}
        pageNumData={itAssetTableDetails.pageNumber}
        searchFuncData={searchFunction}
        loading={itAssetTableDetails.loader}
      />
    </div>
  );
};

export default observer(ItAssetListForCRM);
